// extracted by mini-css-extract-plugin
export default {"cart-page-body":"CartPage_cart-page-body__f5Xzb","title":"CartPage_title__J5TPy"};